import React from 'react';
import ReactDOM from 'react-dom';
import { AppContainer } from 'react-hot-loader';
import { Provider } from 'react-redux';
import App from './components/App';
import store from './stores';

import { initialize, addTranslationForLanguage, setActiveLanguage } from 'react-localize-redux';
import { en, de, es, fr, it } from './translations';
import find from 'lodash/find';

import browserLanguage from './stores/browserLanguage';

/* Initialize Localization */
const languages = ['en', 'it', 'de', 'es', 'fr'];
const activeLanguage = find(languages, function(lang) { return lang == browserLanguage; }) || languages[0];
store.dispatch(initialize(languages, { defaultLanguage: 'en' }));
store.dispatch(addTranslationForLanguage(en, 'en'));
store.dispatch(addTranslationForLanguage(de, 'de'));
store.dispatch(addTranslationForLanguage(es, 'es'));
store.dispatch(addTranslationForLanguage(fr, 'fr'));
store.dispatch(addTranslationForLanguage(it, 'it'));
store.dispatch(setActiveLanguage(activeLanguage));

ReactDOM.render(
  <AppContainer>
    <Provider store={store}>
      <App />
    </Provider>
  </AppContainer>,
  document.getElementById('app')
);

if (module.hot) {
  module.hot.accept('./components/App', () => {
    const NextApp = require('./components/App').default; // eslint-disable-line global-require

    ReactDOM.render(
      <AppContainer>
        <Provider store={store}>
          <NextApp />
        </Provider>
      </AppContainer>,
      document.getElementById('app')
    );
  });
}



// WEBPACK FOOTER //
// ./client.js